<template>
  <v-flex xs12>
    <v-layout row wrap align-center>
      <section class="section-box empty-alert">
        <v-icon :color="color">fal fa-{{ icon }}</v-icon>
        <div class="empty-alert-content">
          <slot name="content"></slot>
        </div>
        <div class="empty-alert-actions">
          <slot name="actions"></slot>
        </div>
      </section>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  props: ['icon', 'color']
}
</script>

<style scoped>
.section-box {
  color: #757575;
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  padding: 40px 0;
}

.section-box .v-icon {
  font-size: 100px;
  line-height: 1;
  margin-bottom: 30px;
}

.empty-alert-actions {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/EmptyAlert.vue